import { useTranslation } from 'react-i18next'
import { EHumanReviewResolution } from './human-review-requests.type'
import { useMemo } from 'react'

export const useResolutionLabels = (): Record<EHumanReviewResolution, string> => {
  const { t } = useTranslation()
  return useMemo(
    () => ({
      [EHumanReviewResolution.PROCESSED]: t(
        'pages.dashboard.human-review-requests.filters.resolution-processed',
      ),
      [EHumanReviewResolution.UNREACHABLE]: t(
        'pages.dashboard.human-review-requests.filters.resolution-unreachable',
      ),
      [EHumanReviewResolution.CONTACTED]: t(
        'pages.dashboard.human-review-requests.filters.resolution-contacted',
      ),
    }),
    [t],
  )
}
